import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import { InfoBox } from '../presentational/info_box.jsx';
import makeBasePage from '../base_page.jsx';
import { machineryTypeMap } from '../../helpers/siteSurveyDataMapper.js';

export class Confirmation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data:null
    }
  }
  

  componentDidMount() {
    var formStrings = this.props.strings['plannerSiteSurveyQuestions'];

    let kenString = this.formatNumbers(this.props.app.KEN);

    var equ = this.props.app.iotData.equipment;
    let locationStr = (equ.EquipmentAddressPostalCode ? equ.EquipmentAddressPostalCode + ", " : "")
      + (equ.EquipmentAddressName1 ? equ.EquipmentAddressName1 + ", " : "")
      + (equ.EquipmentAddressCity1 ? equ.EquipmentAddressCity1 : "");

    const data = [
      {
        name: this.props.strings.KoneEquipment.KEN,
        value: kenString
      },
      {
        name: this.props.strings.KoneEquipment.location,
        value: locationStr
      }
    ];

    var collectedData = this.props.app?.collectedData?.['storedFormState'];
    var siteSurveyData = this.props.app?.collectedData?.['siteSurvey'];
    var plannerLeads = this.props.app?.collectedData?.storedPlannerLeads

    if (collectedData) {
      const chosenMachineType = machineryTypeMap[collectedData.machineryType?.value] || null;
      Object.keys(collectedData).forEach(key => {
        const isMachineryComponent = key.includes('machineryGeared') || key.includes('machineryGearless') || key.includes('machineryHydraulic');

        var item = collectedData[key];

        var keyLocalization = key;
        if (formStrings?.fields?.[key])
          keyLocalization = formStrings.fields[key];
          

        if (key.includes("ActionPerformed"))
          keyLocalization = formStrings?.actionPerformed || keyLocalization;

        if (key.includes("AdditionalInfo"))
          keyLocalization = formStrings?.additionalInfo || keyLocalization;

        if (!chosenMachineType || (!isMachineryComponent || key.includes(chosenMachineType))) {
          if (item.value != null && item.value != undefined) {
            var valueLocalization = String(item.value);
  
            if(formStrings?.sharedSelectionOptions && formStrings.sharedSelectionOptions[item.value]) {
              valueLocalization = formStrings.sharedSelectionOptions[item.value]
            }
            
            if (
              valueLocalization &&
              valueLocalization.toString().length > 0 &&
              valueLocalization.toString() !== "0"
            ) {
              data.push({ name: keyLocalization, value: valueLocalization });
            }
  
            if(plannerLeads && plannerLeads[key] ){
              data.push({name: `${this.props.strings.plannerLeads.general.PlannerLeadCreated} (${keyLocalization})`, value: this.props.strings.Common.yes})
            }
          }

          if (item.images) {
            item = siteSurveyData?.[key] ? siteSurveyData[key] : item;
            this.getImageArray(keyLocalization, item).forEach(item => {
              data.push(item);
            });
          }
        }
      });
    }

    this.setState({
      data: data
    });
 
  }

  formatNumbers(numbers) {
    return numbers.split('').reduce((prev, curr, i) => {
      if (i !== 0 && !(i % 3)) {
        return prev + '-' + curr;
      } else {
        return prev + curr;
      }
    }, "");
  };

  getImageArray(keyLocalization, item) {

    var ret = [];

    item.images.forEach(image => {
      ret.push({
        name: keyLocalization,
        error: !image.uploadSuccesfull,
        value: <img className="image-preview" key={image.file.preview} src={image.file.preview} />
      })
    });

    return ret;
  }

  render() {

    return (
      <div className="page-view confirmation" id="confirmation">
        <div>
          <h1 className="ok">{this.props.strings.UpdateConfirmation.confirmationSuccess}</h1>
          <h3>{this.props.strings.UpdateConfirmation.closeTab}</h3>
          <div className="large-icon success-icon" />
        </div>
        {this.state.data && <InfoBox data={this.state.data} />}
      </div>
    );
  }
}

export default connect(null, null)(makeBasePage('UpdateConfirmation')(Confirmation));